// extracted by mini-css-extract-plugin
export default {"slider":"ClickSlider_slider__XK92c","slideConataier":"ClickSlider_slideConataier__XEFN4","slidebtn":"ClickSlider_slidebtn__oV0eW"};